import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getAwards } from '../../awards';
import LocalizedImage from 'components/LocalizedImage';

import './index.scss';

interface Props {
  index: number;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-awards-item');

const Item: React.FC<Enhanced> = ({ t, index }) => {
  const item = getAwards(t)[index];

  return (
    <div className={b()}>
      <div className={b('header')}>
        <LocalizedImage path={item.logo} alt="investments" className={b('logo')} />
      </div>
      <div className={b('title')}>{item.title}</div>
      <div className={b('body')}>
        <div className={b('details')}>{item.details}</div>
      </div>
    </div>
  );
};

export default translate(Item);
